import { createLogic } from 'redux-logic';
import messages from 'App/util/common/messages'

import {
  authLoginError,
  authLogoutError
} from '../actions';

export const authErrorLogic = createLogic({
  type: [authLoginError, authLogoutError],
  // cancelType: [],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({ action }, dispatch, done) {
    // just display error
    messages.alert('Error', action.payload.err);
    done();
  }
});


// WEBPACK FOOTER //
// ./src/util/redux/auth/logic/error.js